import React from 'react';

const News = () => {
  const news = [
    {
      id: 1,
      title: 'Lansare Serviciu Nou: Internet 10 Gbps',
      date: '15 martie 2024',
      image: '/img/news-10gbps.jpg',
      excerpt: 'Suntem mândri să anunțăm lansarea serviciului de internet cu viteza de până la 10 Gbps pentru clienții business.',
      category: 'Servicii Noi'
    },
    {
      id: 2,
      title: 'Extindere Rețea în Regiunea de Nord',
      date: '1 martie 2024',
      image: '/img/news-network-expansion.jpg',
      excerpt: 'Continuăm extinderea rețelei de fibră optică în regiunea de nord a țării, conectând noi localități.',
      category: 'Dezvoltare'
    },
    {
      id: 3,
      title: 'Program de Internship 2024',
      date: '20 februarie 2024',
      image: '/img/news-internship.jpg',
      excerpt: 'Lansăm programul de internship pentru tinerii specialiști în domeniul IT și telecomunicații.',
      category: 'Cariere'
    }
  ];

  return (
    <>
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-4 hero-pattern relative overflow-hidden">
        <div className="container mx-auto text-center relative z-10">
          <div className="max-w-4xl mx-auto bg-white/5 backdrop-blur-lg p-8 rounded-2xl border border-white/10">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 text-white">
              Noutăți și Evenimente
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-white/80">
              Află ultimele noutăți despre serviciile și activitatea noastră
            </p>
          </div>
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-primary/50 to-primary opacity-90"></div>
      </section>

      {/* News Grid */}
      <section className="py-20 px-4 bg-gray-50">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {news.map((item) => (
              <article key={item.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                <img 
                  src={item.image} 
                  alt={item.title}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <div className="flex justify-between items-center mb-4">
                    <span className="text-sm text-primary font-medium">{item.category}</span>
                    <time className="text-sm text-gray-500">{item.date}</time>
                  </div>
                  <h2 className="text-xl font-bold mb-2 text-gray-900">{item.title}</h2>
                  <p className="text-gray-600 mb-4">{item.excerpt}</p>
                  <button className="text-primary font-semibold hover:text-primary-dark transition-colors">
                    Citește mai mult →
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default News;